import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Collapse from 'material-ui/transitions/Collapse';
import Grid from 'material-ui/Grid';

import Input from '../../common/formComponents/Input';
import Slider from '../../common/formComponents/Slider';
import Switch from '../../common/formComponents/Switch';

import { ALLOW_EDIT_MATERIAL_NAME } from '../../../constants/features';
import { OZ_DECIMALS } from '../../../constants/globals';
import { required } from '../../../lib/formValidations';
import Copper from '../../../models/Copper';
import { getLengthUnit, inchToString, numberToInch } from '../../../lib/unitConversions';

const COPPER_PLATING_MIN_INCH = 0;
const COPPER_PLATING_MAX_INCH = 0.005;
const COPPER_PLATING_STEPS = 25;

export function EditCopperFields(props) {
  const { layer, signal, isOuter, lengthUnit } = props;
  const placeholder =`${layer.displayName}`;
  const lUnit = getLengthUnit(lengthUnit);
  const copperPlatingMin = COPPER_PLATING_MIN_INCH
  const copperPlatingMax = COPPER_PLATING_MAX_INCH;
  const copperPlatingStep = (copperPlatingMax - copperPlatingMin) / COPPER_PLATING_STEPS;

  return (
    <div>
      {ALLOW_EDIT_MATERIAL_NAME ? (
        <Field
          id="name"
          name="name"
          label={placeholder}
          component={Input}
          fullWidth
        />
      ) : null}
      <Grid container spacing={24}>
        <Grid item xs={12} md={4}>
          <Field
            id="signal"
            name="signal"
            legend="Layer Type"
            trueLabel="Signal Layer"
            falseLabel="Switch to Signal Layer"
            component={Switch}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Collapse in={signal} unmountOnExit>
            <Grid container spacing={24}>
              <Grid item xs={12} md={6}>
                <Field
                  id="width"
                  name="transmissionWidth"
                  label="Width of Transmission line"
                  parse={value => Number(value)}
                  convert={value => numberToInch(value, lUnit.name)}
                  inverseConv={value => inchToString(value, lUnit.name, false)}
                  min={0}
                  step={0.0001}
                  fullWidth
                  required
                  component={Input}
                  type="number"
                  suffix={lUnit.symbol}
                  validate={[required]}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  id="spacing"
                  name="transmissionSpacing"
                  label="Spacing between Transmission lines"
                  min={0}
                  step={0.0001}
                  parse={value => Number(value)}
                  convert={value => numberToInch(value, lUnit.name)}
                  inverseConv={value => inchToString(value, lUnit.name, false)}
                  fullWidth
                  required
                  component={Input}
                  type="number"
                  suffix={lUnit.symbol}
                  validate={[required]}
                />
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Grid>
      <Field
        name="weight"
        label="Weight"
        min={0.25}
        max={3.0}
        step={0.25}
        component={Slider}
        labelFormat={value => `${value.toFixed(OZ_DECIMALS)} oz`}
        type="number"
      />
      <Field
        name="copperFill"
        label="Copper Fill"
        min={0.01}
        max={1}
        step={0.01}
        labelFormat={value => `${(value * 100).toFixed(1)} %`}
        component={Slider}
        type="number"
      />
      {isOuter ? (
        <Field
          name="plating"
          label="Copper Plating"
          unit={lUnit.symbol}
          min={copperPlatingMin}
          max={copperPlatingMax}
          step={copperPlatingStep}
          precision={lUnit.decimals}
          labelFormat={(value) => inchToString(value, lengthUnit, true, false)}
          component={Slider}
          type="number"
        />
      ) : null}
    </div>
  );
}

EditCopperFields.defaultProps = {
  signal:     false,
}

EditCopperFields.propTypes = {
  layer:      PropTypes.instanceOf(Copper).isRequired,
  isOuter:    PropTypes.bool.isRequired,
  signal:     PropTypes.bool,
  lengthUnit: PropTypes.string.isRequired,
};

export default EditCopperFields;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/EditCopperFields.js